module.exports = __webpack_public_path__ + "static/media/product.9c50bec9.svg";